/**
 * Device detection utilities
 */

export type DeviceType = 'ios' | 'android' | 'desktop'

/**
 * Core device detection logic from User-Agent string
 * @param userAgent - User-Agent string to parse
 * @returns Device type
 */
export function detectDeviceFromUA(userAgent: string): DeviceType {
  const ua = userAgent.toLowerCase()

  // Check for iOS devices
  if (/iphone|ipad|ipod/.test(ua)) {
    return 'ios'
  }

  // Check for Android devices
  if (/android/.test(ua)) {
    return 'android'
  }

  // If not iOS or Android, it's desktop
  return 'desktop'
}

/**
 * Client-side device detection using browser's User-Agent
 * @returns 'ios' | 'android' | 'desktop'
 */
export function detectDevice(): DeviceType {
  if (typeof window === 'undefined') {
    return 'desktop' // Server-side rendering fallback
  }

  return detectDeviceFromUA(window.navigator.userAgent)
}

/**
 * Check if the current device is iOS
 */
export function isIOS(): boolean {
  return detectDevice() === 'ios'
}

/**
 * Check if the current device is Android
 */
export function isAndroid(): boolean {
  return detectDevice() === 'android'
}

/**
 * Check if the current device is desktop (not mobile)
 */
export function isDesktop(): boolean {
  return detectDevice() === 'desktop'
}
